// Use this file to mock specific GraphQL fields for local testing

// See https://docs.cbhq.net/frontend/data-layer/guides/field-level-mocker
export const fieldOverrides = [
  {
    fieldOverride: [
      // Import any of these helpers from the overrides directory
      // ...unitedStatesUser,
      // ...negativeAvailableToSend,
      // ...geofenceUsdc,
      // ...cardAndAchSourceOfFunds,
      // ...multichainBtc,
      // ...p2pAllowedRecipients,
      // ...guestCheckoutTesting,
      // ...applePayApiTesting,
    ],
  },
];
